module.exports = __webpack_public_path__ + "img/teacher04.fa2d122e.png";